import { render, staticRenderFns } from "./xyk.vue?vue&type=template&id=a1904d5a&scoped=true"
import script from "./xyk.vue?vue&type=script&lang=js"
export * from "./xyk.vue?vue&type=script&lang=js"
import style0 from "./xyk.vue?vue&type=style&index=0&id=a1904d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1904d5a",
  null
  
)

export default component.exports